import { cn } from '@/lib/utils'

export const USER_AVATAR_COLORS = [
  '#FF6969',
  '#FF8132',
  '#FFB800',
  '#9BCF3B',
  '#33C75A',
  '#3EC4C7',
  '#45B8FF',
  '#4577FF',
  '#3A419D',
  '#7B61FF',
  '#B84ED3',
  '#FF61A0',
] as const

export function getUserAvatarColor(seed: string | number): string {
  const normalizedSeed = String(seed).trim().normalize('NFC')
  let hash = 2166136261

  for (const character of normalizedSeed) {
    hash ^= character.codePointAt(0) ?? 0
    hash = Math.imul(hash, 16777619)
  }

  return USER_AVATAR_COLORS[(hash >>> 0) % USER_AVATAR_COLORS.length]
}

interface UserInitialAvatarProps {
  name?: string | null
  seed?: string | number | null
  className?: string
}

export function UserInitialAvatar({ name, seed, className }: UserInitialAvatarProps) {
  const normalizedName = name?.trim().normalize('NFC') ?? ''
  const initial = Array.from(normalizedName)[0] ?? '나'

  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full font-semibold text-lc-text-inverse',
        className,
      )}
      style={{ backgroundColor: getUserAvatarColor(seed ?? normalizedName) }}
    >
      {initial}
    </span>
  )
}
